import React from "react";
import { ReactElement } from "react";

import { useLocation } from "react-router-dom";
import useBreadcrumbs from "use-react-router-breadcrumbs";

import { routes } from "../../config/routes";

import {
  Alink,
  BreadcrumbsList,
  Circle,
  NavContainer
} from "./styles";

export const Breadcrumbs = (): ReactElement | null => {
  const breadcrumbs = useBreadcrumbs(routes);
  const location = useLocation();
  const isMainPage = location.pathname === "/";

  return (
    <NavContainer isMainPage={isMainPage}>
      {!isMainPage && (
        <BreadcrumbsList>
          <Circle />
          {breadcrumbs.map(({ match, breadcrumb }, index) => (
            <li key={match.pathname}>
              <Alink
                isActive={match.pathname === location.pathname}
                href={match.pathname}
              >{index !== 0 ? "/‎ " : ""}{breadcrumb}</Alink>
            </li>
          ))}
        </BreadcrumbsList>
      )}
    </NavContainer>
  );
}
